// Automatisch gegenereerd door tools/generate-dto.mjs — niet handmatig wijzigen.
// Bij herGeneratie worden imports, constructor-body en static create bewaard.

import * as _ from 'lodash';
import { ILevelDomainDto } from 'src/app/infrastructure/models/level-domain-dto';
import { IClaimData, claimData } from 'src/app/features/claim/models/claim-data';
import { isEmptyObject } from 'src/app/infrastructure/functions/is-empty-object.function';
import { IPageDto } from './page-dto.g';
import { IPageComponentDto } from './page-component-dto.g';
import { IClaimActionDto } from './claim-action-dto.g';
import { activityDto, ActivityDto, IActivityDto } from './activity-dto.g';
import { IActivityRefDto } from './activity-ref-dto.g';
import { IPageComponentRefDto } from './page-component-ref-dto.g';
import { IClaimActionRefDto } from './claim-action-ref-dto.g';

export const claimDto = {
    guid: 'guid',
    nr: 'nr',
    name: 'name',
    page_Guid: 'page_Guid',
    pageComponent_Guid: 'pageComponent_Guid',
    claimAction_Guid: 'claimAction_Guid',
    deleted: 'deleted',
    inactive: 'inactive',
    allowedReadOnly: 'allowedReadOnly',
    activitiesDto: 'activitiesDto',
    pageDto: 'pageDto',
    pageComponentDto: 'pageComponentDto',
    claimActionDto: 'claimActionDto',
} as const;

export type TClaimDto = (typeof claimDto)[keyof typeof claimDto];

export const claimDtoConstraints = {
    page_Guid: { required: true },
    pageComponent_Guid: { required: true },
    claimAction_Guid: { required: true },
    guid: { required: true },
} as const;

export type TClaimDtoConstraints = typeof claimDtoConstraints;

export interface IClaimDto extends ILevelDomainDto {
    [claimDto.guid]: string | null;
    [claimDto.nr]: number | null;
    [claimDto.name]: string | null;
    [claimDto.page_Guid]: string | null;
    [claimDto.pageComponent_Guid]: string | null;
    [claimDto.claimAction_Guid]: string | null;
    [claimDto.deleted]: boolean | null;
    [claimDto.inactive]: boolean | null;
    [claimDto.allowedReadOnly]: boolean | null;
    [claimDto.activitiesDto]: IActivityRefDto[] | null;
    [claimDto.pageDto]: IPageDto | null;
    [claimDto.pageComponentDto]: IPageComponentRefDto | null;
    [claimDto.claimActionDto]: IClaimActionRefDto | null;
}

export class ClaimDto
    implements IClaimDto
{
    [claimDto.guid]: string | null = null;
    [claimDto.nr]: number | null = null;
    [claimDto.name]: string | null = null;
    [claimDto.page_Guid]: string | null = null;
    [claimDto.pageComponent_Guid]: string | null = null;
    [claimDto.claimAction_Guid]: string | null = null;
    [claimDto.deleted]: boolean | null = null;
    [claimDto.inactive]: boolean | null = null;
    [claimDto.allowedReadOnly]: boolean | null = null;
    [claimDto.activitiesDto]: IActivityRefDto[] | null = null;
    [claimDto.pageDto]: IPageDto | null = null;
    [claimDto.pageComponentDto]: IPageComponentRefDto | null = null;
    [claimDto.claimActionDto]: IClaimActionRefDto | null = null;

    private constructor(
        modelData?: IClaimData | null, includeRefs = true
    ) {
        if (!modelData || isEmptyObject(modelData)) return;

        this[claimDto.guid] = modelData[claimData.guid];
        this[claimDto.nr] = modelData[claimData.nr];
        this[claimDto.name] = modelData[claimData.name];
        this[claimDto.deleted] = modelData[claimData.deleted];
        this[claimDto.inactive] = modelData[claimData.inactive];
        this[claimDto.allowedReadOnly] = modelData[claimData.allowedReadOnly];

        this[claimDto.page_Guid] = modelData[claimData.page_guid];
        this[claimDto.pageComponent_Guid] = modelData[claimData.pageComponent_guid];
        this[claimDto.claimAction_Guid] = modelData[claimData.claimAction_guid];

        if (!includeRefs) return;


        this[claimDto.activitiesDto] = modelData[claimData.activitiesData]
            ?.map(item => ActivityDto.create(item))
            .filter((a): a is IActivityDto => a !== null)
            .sort((a, b) => (a[activityDto.name] ?? '').localeCompare(b[activityDto.name] ?? ''))
            ?? null;

    }

    static create(modelData?: IClaimData | null, includeRefs = true): IClaimDto | null {
        return modelData ? new ClaimDto(modelData, includeRefs) : null;
    }
}
